// Time-of-day greeting helpers. All time buckets use the caller's local
// timezone via Date.getHours(). Buckets:
//   05:00 – 11:59  → morning
//   12:00 – 16:59  → afternoon
//   17:00 – 21:59  → evening
//   22:00 – 04:59  → evening (folded — safer than "late night" which reads odd)

export function timeOfDay(now = new Date()) {
  const h = now.getHours();
  if (h >= 5 && h < 12) return 'morning';
  if (h >= 12 && h < 17) return 'afternoon';
  return 'evening';
}

export function greeting(firstName, now = new Date()) {
  const part = timeOfDay(now);
  const base = part === 'morning'
    ? 'Good morning'
    : part === 'afternoon'
    ? 'Good afternoon'
    : 'Good evening';
  const trimmed = String(firstName || '').trim();
  return trimmed ? `${base}, ${trimmed}` : base;
}

// Extracts a display-friendly first name from a Firebase user object.
// Falls back to the local part of the email if no displayName is set.
export function firstNameFromUser(user) {
  if (!user) return '';
  const name = user.displayName || user.email || '';
  const token = String(name).trim().split(/\s|@/)[0] || '';
  return token;
}

// Rotating gerunds for the course-request hero. Curated so every entry
// reads naturally in the two sentence patterns:
//   Self:   "What are we {verb}, {name}?"
//   Parent: "What's {name} {verb} today?"
// Picked once per local day and persisted in localStorage so the copy stays
// stable during a session and rotates fresh each morning — not on every
// page mount, which felt jittery.
const LEARNING_VERBS = [
  'learning',
  'grasping',
  'studying',
  'mastering',
  'exploring',
  'discovering',
  'tackling',
  'practicing',
];

const VERB_STORAGE_KEY = 'graspd.hero.verb';

function todayKey(now = new Date()) {
  const yyyy = now.getFullYear();
  const mm = String(now.getMonth() + 1).padStart(2, '0');
  const dd = String(now.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}

function randomVerb() {
  return LEARNING_VERBS[Math.floor(Math.random() * LEARNING_VERBS.length)];
}

export function pickLearningVerb(now = new Date()) {
  const dateKey = todayKey(now);
  // Try to return today's persisted verb.
  try {
    const raw = window.localStorage.getItem(VERB_STORAGE_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (
        parsed &&
        parsed.dateKey === dateKey &&
        LEARNING_VERBS.includes(parsed.verb)
      ) {
        return parsed.verb;
      }
    }
  } catch {
    // localStorage unavailable (SSR / privacy mode) — fall through to random.
  }
  const verb = randomVerb();
  try {
    window.localStorage.setItem(
      VERB_STORAGE_KEY,
      JSON.stringify({ verb, dateKey })
    );
  } catch {
    // Ignore storage failures — worst case is a fresh verb next mount.
  }
  return verb;
}
